/**
 * Extract tenant group from Cognito session
 * Filters out system_admin and admin groups to get the actual tenant group
 * 
 * @param {Object} session - Cognito session object from Auth.signIn()
 * @returns {string|null} - Tenant group or null if not found
 */
export function getTenantGroupFromSession(session) {
  if (!session || !session.signInUserSession) {
    console.warn('getTenantGroupFromSession: Invalid session object');
    return null;
  }

  const userGroups = session.signInUserSession.accessToken.payload['cognito:groups'] || [];
  const tenantGroup = userGroups.find(g => g !== 'system_admin' && g !== 'admin');
  
  console.log('Auth Helper - User Groups:', userGroups);
  console.log('Auth Helper - Extracted Tenant Group:', tenantGroup);
  
  return tenantGroup || null;
}

/**
 * Extract user ID from Cognito session
 * 
 * @param {Object} session - Cognito session object from Auth.signIn()
 * @returns {string|null} - User ID or null if not found
 */
export function getUserIdFromSession(session) {
  if (!session || !session.attributes) {
    console.warn('getUserIdFromSession: Invalid session object');
    return null;
  }

  return session.attributes['custom:user_id'] || null;
}

/**
 * Get tenant group from Vuex store userInfo
 * Safe accessor that handles missing data gracefully
 * 
 * @param {Object} store - Vuex store instance (this.$store)
 * @returns {string|null} - Tenant group or null if not found
 */
export function getTenantGroupFromStore(store) {
  if (!store || !store.state || !store.state.userInfo) {
    console.warn('getTenantGroupFromStore: Invalid store or userInfo');
    return null;
  }

  const group = store.state.userInfo.tenant?.group;
  
  if (!group) {
    console.warn('getTenantGroupFromStore: Tenant group not found in userInfo');
  }
  
  return group || null;
}

/**
 * Get user ID from Vuex store userInfo
 * Safe accessor that handles missing data gracefully
 * 
 * @param {Object} store - Vuex store instance (this.$store)
 * @returns {string|null} - User ID or null if not found
 */
export function getUserIdFromStore(store) {
  if (!store || !store.state || !store.state.userInfo) {
    console.warn('getUserIdFromStore: Invalid store or userInfo');
    return null;
  }

  const userId = store.state.userInfo.id;
  
  if (!userId) {
    console.warn('getUserIdFromStore: User ID not found in userInfo');
  }
  
  return userId || null;
}

/**
 * Extract tenant group from user/row group field
 * Filters out system_admin and admin groups to get the actual tenant group
 * Handles both array and string group formats
 * 
 * @param {string|string[]} groupField - Group field from user/row object (can be string or array)
 * @param {string} fallbackGroup - Fallback group to use if no tenant group found
 * @returns {string} - Tenant group or fallback group
 */
export function extractTenantGroup(groupField, fallbackGroup = '') {
  if (!groupField) {
    return fallbackGroup;
  }

  // Normalize to array
  const groups = Array.isArray(groupField) ? groupField : [groupField];
  
  // Find first group that is not system_admin or admin
  const tenantGroup = groups.find(g => g !== 'system_admin' && g !== 'admin');
  
  return tenantGroup || fallbackGroup;
}
